/* eslint-disable camelcase */
/**
 * 浙里办APP
 * 应用开放平台 aplusJS 埋点
 */
const MINI_APP_ID = '2001999672'
const MINI_APP_NAME = '浙里金融'
let IP = '';

(function () {
  window.aplus_queue = window.aplus_queue || []
  if (document.getElementById('beacon-aplus')) return
  const brother = document.getElementsByTagName('script')[0]
  const element = document.createElement('script')
  element.id = 'beacon-aplus'
  element.async = true
  element.src = 'https://alidt.alicdn.com/alilog/mlog/aplus_cloud.js?v=20200518'
  brother.parentNode.insertBefore(element, brother)

  const { aplus_queue } = window

  /* 基础采集 */
  // 一般日志（如点击、曝光）接收日志域名配置,action为接口名称，arguments为第一个为参数形参，第二个为参数值
  try {
    aplus_queue.push({
      action: 'aplus.setMetaInfo', arguments: ['aplus-rhost-g', 'alog.zjzwfw.gov.cn']
    })
  } catch (error) {
    console.log('发生异常:' + error)
  }

  try {
    aplus_queue.push({
      action: 'aplus.setMetaInfo', arguments: ['aplus-rhost-v', 'alog.zjzwfw.gov.cn']
    })
  } catch (error) {
    console.log('发生异常:' + error)
  }

  try {
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appId', '74781848']
    })
  } catch (error) {
    console.log('发生异常:' + error)
  }

  fetch('https://www.zjzwfw.gov.cn/zjservice/home/getIp.do').then(res => {
    return res.text()
  }).then(data => {
    IP = data
  }).catch(error => {
    console.log('发生异常:' + error)
  })
})()

/** PV日志采集 */
const aplusPV = (queue) => {
  queue.push({
    action: 'aplus.sendPV',
    arguments: [
      {
        is_auto: false
      },
      {
        isMini: true,
        miniAppId: MINI_APP_ID,
        miniAppName: MINI_APP_NAME
      }
    ]
  })
}

/** UV日志采集 */
const aplusUV = (userInfo, queue) => {
  const { userId, userid, username } = userInfo
  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_user_id', userId || userid]
  })
  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_user_nick', username]
  })
  let uAgent = window.navigator.userAgent
  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_dev_id', uAgent]
  })
}

const aplusRecord = (userInfo, queue) => {
  try {
    const pageName = document.querySelector('title').innerText
    const page_type = document.querySelector("meta[name='ColumnType']").content
    const site_id = document.querySelector("meta[name='SiteIDCode']").content
    const t1 = new Date().getTime()
    const { userId, userid, username, userType } = userInfo
    let t0

    var newParam = {
      // seedClass: param.seedClass || "mqy_click_button",
      'refer_page_name': pageName,
      'biz_user_id': userId || userid,
      'biz_user_nick': username,
      'page_type': page_type,
      'userType': userType,
      'site_id': site_id,
      't0': t0,
      'IP': IP,
      't1': t1,
      'refer_page': document.referrer,
      'page': window.location.href
    }
    queue.push({
      'action': 'aplus.record',
      'arguments': ['zjzwIndexExpose', 'EXP', encodeURI(JSON.stringify(newParam)), 'GET']
    })
  } catch (error) {
    console.log('发生异常:' + error)
  }
}

/** 执行aplus埋点程序 */
const aplus = async (userInfo = {}) => {
  console.log('userInfo: ', userInfo)
  const queue = []
  /* 如采集用户信息是异步行为需要先执行这个 BLOCK 埋点 */
  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'BLOCK']
  })
  // 单页应用 或 “单个页面”需异步补充 PV 日志参数还需进行如下埋点：
  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN']
  })

  aplusPV(queue)

  aplusUV(userInfo, queue)

  aplusRecord(userInfo, queue)

  queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'START']
  })

  console.log('采集完成', queue)

  window.aplus_queue.push(...queue)
}

export default aplus
